import { values } from 'ramda';
import { validString, ConfigurationError } from "../../utility";

export const createConfig = configObj => {
  const vals = values(configObj);
  const allValid = vals.every(con => validString (1) (con.action));
  if (!allValid) {
    throw ConfigurationError('Provide an action for a valid configuration');
  }
  return configObj;
}

export const getConfiguration = ConfigDict => (key) => {
  const config = ConfigDict[key];
  if (config) {
    return config;
  } else {
    throw ConfigurationError('No Config Found in Dict');
  }
};
